module.exports = __webpack_public_path__ + "img/hfdl-banner-2@2x.eedfd45e.png";